export const iconFontAwesomeLogisticsPlaneCircleXmark = (
	<i className="fa-solid fa-plane-circle-xmark"></i>
);
